module.exports = __webpack_public_path__ + "img/jay.60a00a5f.jpg";